module.exports = __webpack_public_path__ + "static/img/youxuandaquan.a47031a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/youxuandaquan.png
// module id = nbFe
// module chunks = 1